module.exports = __webpack_public_path__ + "img/cb-r-r1.6592ad8d.gif";